<template>
  <div>
    <wh-popup-dynamic-select
      ref="list"
      :extra-params="extraParams"
      :rules="rules"
      :show-picker.sync="pickerShow"
      :value="selectedAgriculturalNames"
      data-src="/api/getAgriculturalList"
      history-key="farmWorkAgricultural"
      label="投入品"
      name="agriculturalRecordInfos"
      placeholder="请选择投入品"
      search-name="keyword"
      search-placeholder="输入关键字搜索"
      @close="$emit('close')"
    >
      <template #special>
        <div style="min-width:80px;border: none;color: #31C267" @click="handleAddAgr">
          新增农资
        </div>
      </template>
      <template #list="{list}">
        <van-form
          ref="selectedAgriculturalForm"
          class="agricultural-form"
          @submit="submitAgriculturalSelectForm"
        >
          <transition-group name="agricultural-select-list">
            <div
              v-for="item in myAgriculturalRecordInfos"
              :key="item.id"
              class="wh-flex-between agricultural-select-list-item"
            >
              <div class="left-content">
                <van-tag size="large" type="primary">
                  {{ item.name }}
                </van-tag>
                <div class="size">
                  规格：{{ item.num }}{{ item.unit }}/{{ item.pack }}
                </div>
              </div>
              <div class="wh-flex-between">
                <van-field
                  v-model.number="item.changeCount"
                  :rules="changeCountRule(item)"
                  placeholder="填入使用量"
                  style="width: 140px;"
                  type="number"
                />
                <span style="width: 20px;"> {{ item.unit }}</span>
              </div>
            </div>
          </transition-group>
        </van-form>
        <div class="agricultural-list">
          <div
            v-for="(item, index) in list"
            :key="index"
            :class="[isSelected(item.id) ? 'selected' : '']"
            :title="index"
            class="agricultural-list-item van-hairline--bottom"
            @click="toggledItem(item.id, list)"
          >
            <van-icon v-show="isSelected(item.id)" class="selected-icon" name="certificate" />
            <div class="wh-flex-between">
              <div class="left-content">
                <div class="name">
                  <van-tag round size="large" type="primary">
                    {{ item.name }}
                  </van-tag>
                </div>
                <van-tag class="factory" size="medium">
                  {{ item.factory }}
                </van-tag>
              </div>
              <div class="right-content">
                <div>
                  <span style="font-size: 14px;">剩余：</span>
                  <van-tag class="change-count" type="success">
                    {{ item.count }} {{ item.unit }}
                  </van-tag>
                </div>
                <div class="specification">
                  {{ item.num }} {{ item.unit }}/{{ item.pack }} ({{ item.price }} 元)
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="agricultural-submit-box">
          <van-button block class="submit" native-type="button" type="primary" @click="submitAgriculturalSelect">
            确定
          </van-button>
        </div>
      </template>
    </wh-popup-dynamic-select>
    <create-agr-popup :visible.sync="show" @dialogClose="handleLoad" />
  </div>
</template>

<script>
import WhPopupDynamicSelect from '@/components/public/WhPopupSelect/WhPopupDynamicSelect'
import CreateAgrPopup from '@/views/Agricultural/createAgrPopup'

export default {
  name: 'AgriculturalPopupSelect',
  components: { WhPopupDynamicSelect, CreateAgrPopup },
  model: {
    prop: 'agriculturalRecordInfos',
    event: 'change'
  },
  props: {
    agriculturalRecordInfos: {
      type: Array,
      default() {
        return []
      }
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      show: false,
      historyList: [],
      myAgriculturalRecordInfos: [],
      selectedAgriculturalNames: '',
      pickerShow: false,
      extraParams: {
        fuzzy: 1,
        userId: this.$store.getters.userData.id,
        having: 'having',
        type: 'all'
      },
      selectedItem: {
        ids: []
      }
    }
  },
  watch: {
    agriculturalRecordInfos: {
      handler(newVal) {
        this.myAgriculturalRecordInfos = newVal.map(item => {
          return {
            ...item,
            oldChangeCount: item.oldChangeCount || item.changeCount || 0
          }
        })
        // console.log(this.myAgriculturalRecordInfos)
        this.selectedItem.ids = newVal.map(item => item.agriculturalId)
        this.selectedAgriculturalNames = newVal.map(item => item.name).join(',')
      },
      immediate: false
    }
  },
  methods: {
    handleAddAgr() {
      this.show = true
    },
    isSelected(id) {
      return this.selectedItem.ids.includes(id)
    },
    changeCountRule(item) {
      const validateChangeCount = (value) => {
        // 编辑时使用量不能超过已使用量加库存量之和, 编辑时后端可能未返回 count 字段，已告知添加
        if (item.oldChangeCount) {
          return value <= (item.count + item.oldChangeCount)
        }
        return value <= item.count
      }
      return [
        { required: true, message: '请填入使用量' },
        { validator: validateChangeCount, trigger: 'onBlur', message: '不能超过库存量' },
        {
          validator: (value) => {
            return value > 0
          }, trigger: 'onBlur', message: '使用量不能小于等于0'
        }
      ]
    },
    submitAgriculturalSelect() {
      this.$refs.selectedAgriculturalForm.submit()
    },
    handleLoad(flag) {
      if (!flag) {
        this.$refs.list.$refs.list.onRefresh()
      }
    },
    submitAgriculturalSelectForm(form) {
      this.selectedAgriculturalNames = this.myAgriculturalRecordInfos.map(item => item.name).join(',')
      this.selectedItem.ids = this.myAgriculturalRecordInfos.map(item => item.agriculturalId)
      this.pickerShow = false
      this.$emit('change', this.myAgriculturalRecordInfos) // 更新有效数据
    },
    toggledItem(itemId, list) {
      // console.log(this.historyList', this.historyList)
      // console.loglist', list)
      const historyListId = this.historyList.map(item => item.id) || []
      const noIncludeList = list.filter(({ id }) => !historyListId.includes(id))
      this.historyList.push(...noIncludeList)
      let exist = false
      for (const index in this.selectedItem.ids) {
        if (this.selectedItem.ids[index] === itemId) {
          this.selectedItem.ids.splice(index, 1)
          exist = true
          break
        }
      }
      if (!exist) {
        this.selectedItem.ids.push(itemId)
      }
      this.myAgriculturalRecordInfos = this.historyList.filter(item => {
        return this.selectedItem.ids.includes(item.id)
      }).map(
        item => {
          // 保留输入值
          let changeCount
          let oldChangeCount
          const exist = this.myAgriculturalRecordInfos.find(selectItem => selectItem.agriculturalId === item.id)
          if (exist && this.isSelected(exist.agriculturalId)) {
            changeCount = exist.changeCount
            oldChangeCount = exist.oldChangeCount
          }
          return {
            ...item,
            changeCount: changeCount,
            oldChangeCount: oldChangeCount,
            agriculturalId: item.id
          }
        })
    }
  }
}
</script>

<style lang='less' scoped>
.agricultural-list {
  .agricultural-list-item {
    margin: 10px;
    padding: 10px;
    position: relative;
    &.selected {
      background: #cccccc;
      .selected-icon {
        position: absolute;
        right: -6px;
        top: -6px;
        font-size: 20px;
        background: @primary-color;
        color: #fff;
        border-radius: 100%;
      }
    }
    .left-content {
      .factory {
        margin-top: 10px;
      }
    }
    .right-content {
      text-align: right;
      .specification {
        margin-top: 5px;
      }
    }
  }
}
.agricultural-select-list-item {
  margin: 10px;
  border-bottom: 1px solid #ccc;
  align-items: start;
  .left-content {
    .size {
      margin-top: 4px;
    }
  }
}
.agricultural-select-list-item,
.agricultural-select-list-enter-active,
.agricultural-select-list-leave-active {
  transition: all 0.3s;
  height: 70px;
}
.agricultural-select-list-enter, .agricultural-select-list-leave-to {
  opacity: 0;
  transform-origin: top center;
  height: 0;
  transform: scaleY(0);
}
.agricultural-submit-box {
  @height: 40px;
  height: @height; //用于占位
  display: block;
  width: 100%;
  .submit {
    height: @height;
    position: fixed;
    letter-spacing: 0.2em;
    bottom: 0;
    left: 0;
    padding: 20px 0 30px 0;
  }
}
</style>
